<template>
  <div>
    <van-row style="margin: 10px 0">
      <div class="content_good">
        <div class="food_div">
          <!-- <van-icon name="bars" /> -->
          <img class="food_list" src="@/assets/img/食物.png" alt="" />
          &nbsp;&nbsp; <span>食材清单</span>
        </div>
        <div >
          <p class="mgTop20">主料商品</p>
          <ul class="mgTop20">
            <li
              :class="{
                cook_li_mian: true,
                 cell_cover: item.salePrice == null,
              }"
              v-for="item in tradeCookbookDtlDTOS.filter(
                (el) => el.classifyValue == 0
              )"
              :key="item.skuId"
              @click='goodsDetails(item)'
            >
             <div class='cover_img'>
              <img :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" alt />
             </div>
              <div class="inline detail_li">
                <div class="goods_over text_ccc fSize_14">
                  {{ item.goodsName + "(" + item.skuName + ")" }}
                </div>
                  <div class="text_yellow" v-if="item.salePrice == null">
                   <div>商品失效</div>
                  </div>
                  <div v-else>
                    <div>
                    <span>¥{{ item.salePrice }}</span>
                    <span class="fSize_14"> / {{
                        item.saleUnitLabel
                          | filterUnit(item.saleRatio, item.goodsUnitLabel)
                      }}
                    </span>
                    </div>
                  <div style="margin-top: 5px">
                  <input
                    @click.stop="stopstop"
                    style="color:#222222"
                    v-model="item.parameter"
                    class="input_par"
                    type="text"
                  />
                  <span class="text_999"> {{ item.goodsUnitLabel }}/份</span> 
                  </div>
                  </div>
                </div>
                   <van-button
                    class="float_right line_detele"
                    round
                    @click.stop="deleteInfo(item)"
                    type="info"
                    size="small"
                    >删除</van-button
                  >
            </li>
          </ul>
          <div class="btn_col mgTop20">
            <van-button
              class="addBtn"
              hairline
              plain
              round
              @click="addMain(true)"
              type="default"
              size="large"
              >+ 添加主料商品</van-button
            >
          </div>
        </div>
      </div>
      <div class="content_good">
        <p class="mgTop20">辅料商品</p>
        <ul class="mgTop20" >
            <li
              :class="{
                cook_li_mian: true,
                 cell_cover: item.salePrice == null,
              }"
              v-for="item in tradeCookbookDtlDTOS.filter(
                (el) => el.classifyValue == 1
              )"
              :key="item.skuId"
              @click='goodsDetails(item)'
            >
             <div class='cover_img'>
              <img :src="item.picUrl ? item.picUrl : '@/assets/头像图片.png'" alt />
              </div>
              <div class="inline detail_li">
                <div class="goods_over text_ccc fSize_14">
                  {{ item.goodsName + "(" + item.skuName + ")" }}
                </div>
                <div class="text_yellow"     >
                  <div  class="text_yellow" v-if="item.salePrice == null"
                    >商品失效</div
                  >
                  <div  v-else>
                    <span>¥{{ item.salePrice }}</span>
                    <span class="fSize_14"> / {{ 
                        item.saleUnitLabel
                          | filterUnit(item.saleRatio, item.goodsUnitLabel)
                      }}
                    </span>
                     <div style="margin-top: 5px">
                  <input
                  @click.stop="stopstop"
                  style="color:#222222"
                    v-model="item.parameter"
                    class="input_par"
                    type="text"
                  />
                  <span class="text_999"> {{ item.goodsUnitLabel }}/份</span>
                </div>
                  </div>
                </div>
              </div>
                  <van-button
                    class="float_right line_detele"
                    round
                    @click.stop="deleteInfo(item)"
                    type="info"
                    size="small"
                    
                    >删除</van-button
                  >
            </li>
          </ul>
        <div class="btn_col mgTop20">
          <van-button
            class="addBtn"
            hairline
            plain
            round
            @click="addMain(false)"
            type="default"
            size="large"
            >+ 添加辅料商品</van-button
          >
        </div>
      </div>
    </van-row>
   <van-popup v-if="show" lock-scroll :close-on-click-overlay='false'  round position="bottom"  :style="{height: '80%',overflow:'hidden'}"  v-model="show">
      <skuSearch @confirm='onConfirm' :main='main' @close='show=false'  />
   </van-popup>
  </div>
</template>

<script>
import skuSearch from "@/components/common/skuSearch";
export default {
  components: { skuSearch },
  props: {
    info: {
      default: {}
    }
  },
  created() {
    this.tradeCookbookDtlDTOS = this.info.tradeCookbookDtlDTOS || [];
  },
  data() {
    return {
      show: false,
      skuList: [],
      skuName: "",
      searchFalg: false,
      cookbookId: "",
      tradeCookbookDtlDTOS: [],
      main: false //主料
    };
  },
  watch: {
    show() {
      if (!this.show) {
        this.skuName = "";
        this.skuList = [];
      }
    }
  },
  methods: {
    stopstop() {},
    goodsDetails(item) {
      if (item.salePrice == null) return;
      this.$router.push({
        path: "/details",
        query: { goodsId: item.goodsId, got: "true" }
      });
    },
    deleteInfo(params) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          let mainList = this.tradeCookbookDtlDTOS.filter(
            item => item.classifyValue == 0
          );
          let accessoriesList = this.tradeCookbookDtlDTOS.filter(
            item => item.classifyValue == 1
          );
          if (params.classifyValue == 0) {
            // 0为主料；1为辅料
            mainList = mainList.filter(item => {
              return item.skuId != params.skuId;
            });
          } else {
            accessoriesList = accessoriesList.filter(item => {
              return item.skuId != params.skuId;
            });
          }
          this.tradeCookbookDtlDTOS = [...mainList, ...accessoriesList];
          this.$toast("删除成功");
        })
        .catch(() => {});
    },
    // getSkuList(param) {
    //   let obj = {
    //     param,
    //     deliveryTime: Date.now() + 24 * 60 * 60 * 1000,

    //   };
    //   this.$axios.post("trade/tradeOrder/searchSku/price", obj).then((res) => {
    //     this.skuList = res.data.data.map((item) => {
    //       return {
    //         text: this.$set(
    //           item,
    //           "text",
    //           `${item.goodsCode}-${item.goodsName}(${item.skuName})`
    //         ),
    //         parameter: "",
    //         classifyValue: this.main ? 0 : 1,
    //         classifyLabel: this.main ? "主料" : "辅料",
    //         ...item,
    //       };
    //     });
    //   });
    // },
    onConfirm(item) {
      this.show = false;
      if (item.salePrice == null) return this.$toast.error("该商品已失效");
      if (this.tradeCookbookDtlDTOS.length == 0)
        return this.tradeCookbookDtlDTOS.push(item);
      let falg = this.tradeCookbookDtlDTOS.some(ele => {
        if (
          ele.classifyValue == item.classifyValue &&
          ele.skuId == item.skuId
        ) {
          return this.$toast.fail("商品规格重复");
        }
      });
      if (falg) return false;
      this.tradeCookbookDtlDTOS.push(item);
    },
    onChange() {},
    onCancel() {
      this.show = false;
    },
    searchSku(val) {
      this.getSkuList(val);
    },
    addMain(val1) {
      this.show = true;
      this.main = val1;
    }
  }
};
</script>

<style lang='scss' scoped>
.btn_col {
  background-color: #fff;
  padding: 0px 18px;
  .addBtn.van-button--large {
    height: 36px;
    border: 1px dashed rgb(116, 180, 43);
    color: rgb(116, 180, 43);
    background-color: #fff;
  }
}
.addBtn.van-hairline--surround::after {
  border: none;
}
/deep/ .van-field__control {
  width: 100%;
}
// .list {
//   margin: 10px 0;
//   background-color: #fff;
//   padding: 10px 16px;
// }
.list {
  background-color: #fff;
  ul {
    padding: 10px 16px;
    margin-top: 10px;
  }
  // padding: 10px 16px;
}
/deep/ .van-col {
  font-size: 14px;
}
.input_par {
  width: 80px;
  border-style: none;
  border: 1px solid rgb(116, 180, 43);
  border-radius: 5px;
}
/deep/ .van-popup {
  overflow: hidden;
}
</style>